<template>
  <header
    id="component-gallery-header"
    class="
      d-flex
      flex-wrap
      flex-column
      flex-md-row
      p-0
      justify-content-between
      align-items-md-center
      dark-blue
    "
    ref="header"
  >
    <div class="header-logo d-flex mr-md-4" style="height: 87px;">
      <div
        style="position: relative; height: 87px; width: 87px; overflow: hidden"
        class="mr-3"
      >
        <kuosi style="position: absolute; left: 0; top: 0" />
      </div>
      <a class="d-flex align-items-center" :href="path" aria-label="path">
        <component-gallery-logo />
      </a>
    </div>

    <div
      class="header-breadcrumb d-flex align-items-center py-md-4 p-2 p-md-0 mr-md-auto"
    >
      <router-link 
        class="header-link-container frontpage-link"
        :to="{ name: 'frontpage' }"
        @click="removeNullBar()"
      >
        <p class="color-white mb-0 mr-3" style="margin-bottom: 0 !important">
          {{ $t("hellovue.buildings") }}
        </p>
      </router-link>

      <router-link
        v-if="currentCategoryName"
        class="header-link-container categorypage-link"
        :to="{
          name: 'categorypage',
          params: {
            categoryName: createUrlString(currentCategoryName),
          },
        }"
        >
        <p style="margin-bottom: 0 !important">
          <span
            class="icon-chevron-left color-white ml-2"
            style="font-weight: light"
          ></span>
        </p>
        <p class="color-white mb-0 mr-3" style="margin-bottom: 0 !important">
          {{ currentCategoryName }}
        </p>
      </router-link>

      <!-- <div class="header-link-container">
        <p style="margin-bottom: 0 !important">
          <span
            class="icon-chevron-left color-white ml-2"
            style="font-weight: light"
          ></span>
        </p>
        <p
          class="mb-0 color-white px-2 mr-2"
          style="font-weight: bold; margin-bottom: 0 !important"
        >
          {{ $t("hellovue.header.street_view_of_learning_facilities") }}
        </p>
      </div> -->

      <div
        v-if="getName"
        class="header-link-container componentpage-link d-none d-md-flex"
      >
        <p style="margin-bottom: 0 !important">
          <span
            class="icon-chevron-left color-white ml-2"
            style="font-weight: light"
          ></span>
        </p>
        <p class="color-white mb-0">
          <span>{{ getName }}</span>
        </p>
      </div>
    </div>

    <div v-if="currentCategoryId" class="dropdown-container p-2">
      <button
        id="change-type-dropdown"
        @click="activateDropdown()"
        class="dropdown-btn d-flex justify-content-between color-white p-0"
      >
        <span class="color-white">{{
          $t("hellovue.dropdown.change_type")
        }}</span>
        <div>
          <span class="pl-2 icon-chevron-down"></span>
        </div>
      </button>
      <ul
        ref="buildingTypeList"
        id="building-type-list"
        class="dropdown-content"
        :class="{ 'visible-dropdown': componentSelectionDropdownOpen }"
      >
        <li
          v-for="(building, index) in getCategoryTopics(currentCategoryId)" 
          :key="building.id + index"
        >
          <router-link
            :to="{
              name: 'componentpage',
              params: {
                componentName: createUrlString(building.name),
              },
            }"
          >
            {{ building.name }}
          </router-link>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import ChangeLanguage from "src/components/partials/ChangeLanguage";
import componentGalleryLogo from "src/components/icons/Logo";
import { createUrlString } from "src/store/helpers";
import Kuosi from "src/components/icons/Kuosi";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ComponentGalleryHeader",
  components: {
    ChangeLanguage,
    componentGalleryLogo,
    Kuosi,
  },
  activated() {},
  computed: {
    ...mapGetters([
      "getName",
      "getCategoryTopics",
      "componentSelectionDropdownOpen",
      "getCategories",
    ]),
    path: function () {
      return `${location.protocol}//${location.host}`;
    },
    currRouteName() {
      if(this.$route.name === "frontpage"){
        return true
      }else{
        return false
      }
    },
    currentCategory: function () {
      return this.getCategories.find((cat) => createUrlString(cat.name) == this.$route.params.categoryName)
    },
    currentCategoryId: function () {
      if (this.currentCategory && this.currentCategory.id) return this.currentCategory.id;
      return undefined;
    },
    currentCategoryName: function () {
      if (this.currentCategory && this.currentCategory.name) return this.currentCategory.name;
      return undefined;
    }
  },
  methods: {
    ...mapActions(["setComponentSelectionDropdownOpen"]),
    createUrlString,
    activateDropdown() {
      if (this.componentSelectionDropdownOpen) {
        document.getElementById("change-type-dropdown").blur();
      }

      this.setComponentSelectionDropdownOpen(
        !this.componentSelectionDropdownOpen
      );
    },
    removeNullBar() {
      document.querySelector("#component-gallery-content").scrollIntoView({
        block: "end",
        scrollBehavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0 !important;
}

#component-gallery-header {
  margin-left: -33px;
  /* margin-right: -35px; */
  margin-top: -3px;
  padding-left: 50px;
  border-bottom: solid 10px #00a9e0;
}
.dropdown-container {
  position: relative;
}
.dropdown-btn {
  background: transparent;
  color: white;
  border: none;
  box-shadow: none;
}
.dropdown-content {
  background-color: #f9f9f9;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  display: none;
  list-style: none;
  min-width: 240px;
  padding: 12px 16px;
  margin-top: 10px;
  position: absolute;
  right: 0;
  z-index: 1;
}

.visible-dropdown {
  display: block;
}

.header-link-container {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
}
</style>
